// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"88d7dbed","583":"8a269379","624":"7357e779"}[chunkId] + ".chunk.css";
};